// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import iView from 'view-design'
import 'element-ui/lib/theme-chalk/index.css';
import 'view-design/dist/styles/iview.css';
import App from './App'
import router from './router/index.js'
import store from './store';
import './assets/less/globa.less'
import './assets/less/index.less'
import VueClipboard from 'vue-clipboard2'
import VueCoreVideoPlayer from 'vue-core-video-player'
import CONST from './libs/CONST.js'


Vue.use(ElementUI);
Vue.use(VueClipboard)
Vue.use(iView)
Vue.use(VueCoreVideoPlayer)
Vue.config.productionTip = false
// 加载全局变量
CONST()
/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js